
<div class="ui-g">
    <div class="ui-sm-0 ui-md-1 ui-lg-2 ui-xl-2"></div>
    <div class="ui-sm-12 ui-md-10 ui-lg-8 ui-xl-8">
        <div class="ui-g">
            <div class="ui-g-12">
                <h1 class="nuty-color">Dziękujemy za zakupy</h1>
            </div>    
        </div>
        <hr>
        <div class="ui-g" *ngIf="isPrepaidTransaction == true">
            <div class="ui-g-12">
                <p>Twoje konto zostało doładowane kwotą: {{ prepaidAmount | currencyReduce: true | currency:prepaidAmount:'zł'  }}</p>
            </div>
        </div>
        <hr>
        <div class="ui-g">
            <div class="ui-g-12">
                <p class="nuty-color" style="cursor: pointer;" (click)="onGoToMyOrders()">PRZEJDZ DO MOICH ZAMÓWIEŃ</p>
            </div>   
        </div>
    </div>
    <div class="ui-sm-0 ui-md-1 ui-lg-2 ui-xl-2"></div>
</div>


